module.exports = {
      id: "photo-usage",
      viewBox: "0 0 12 9",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#photo",
      toString: function () {
        return this.url;
      }
    }